// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".invoice-price-checkbox{height:55px!important}.invoice-price-checkbox .v-label{word-break:unset!important}.invoice-price-checkbox .v-label,.invoices-filters .v-label{color:#000!important;font-size:23px}.v-table__wrapper{overflow-x:scroll;max-height:500px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
